<template>
  <article class="px-1 py-2 align-self-start deepa-chat-message-server">
    <div
      v-if="message.status === 'pending'"
      class="d-flex align-center ga-2 text-medium-emphasis mb-2"
    >
      <v-progress-circular indeterminate size="16" width="2" />
      <span v-if="message.statusUpdate" class="text-body-small">
        {{ message.statusUpdate }}
      </span>
    </div>
    <v-alert
      v-if="message.status === 'error'"
      density="compact"
      :text="message.error || t('error.error_occurred')"
      type="error"
      variant="tonal"
    />
    <DeepMarkdownRenderer
      v-if="message.content"
      class="text-break"
      :source="message.content"
    />
    <div
      v-if="message.status === 'aborted'"
      class="text-medium-emphasis text-body-small mt-2"
    >
      {{ t('deepa_chat.reply_stopped') }}
    </div>
  </article>
</template>

<script lang="ts" setup>
import { DeepMarkdownRenderer } from '@deepcloud/deep-ui-lib'
import type { DeepAChatServerMessage } from '@/pocs/chat/types'

defineProps({
  message: {
    type: Object as PropType<DeepAChatServerMessage>,
    required: true,
  },
})

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.deepa-chat-message-server :deep(.markdown-renderer p) {
  font-size: 1em;
  margin: 0;
}
</style>
